import React, { useEffect, useMemo, useState } from 'react';
import { Table, Tooltip } from 'antd';
import { formatMoney } from '../../utils/formatMoney';
import { formatNumber } from './dashboardUtils';

function NameCell({ value }) {
  if (!value) return '—';
  return (
    <Tooltip title={value}>
      <span className="dashboard-table-name">{value}</span>
    </Tooltip>
  );
}

export default function ModelDistributionTable({
  data,
  loading,
  nameColumn = 'Model',
  showRequests = true,
  showTokens = true,
  showSpend = true,
  pageSize: defaultPageSize = 10,
}) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  useEffect(() => {
    setPage(1);
  }, [data, pageSize]);

  const columns = useMemo(() => {
    const cols = [
      {
        title: nameColumn,
        dataIndex: 'model',
        key: 'model',
        ellipsis: true,
        render: (value) => <NameCell value={value} />,
      },
    ];

    if (showRequests) {
      cols.push({
        title: 'Requests',
        dataIndex: 'request_count',
        key: 'request_count',
        render: (v) => (v != null ? formatNumber(v) : '—'),
        width: 100,
        align: 'right',
      });
    }

    if (showTokens) {
      cols.push({
        title: 'Tokens',
        dataIndex: 'total_tokens',
        key: 'total_tokens',
        render: (v) => (v != null ? formatNumber(v) : '—'),
        width: 110,
        align: 'right',
      });
    }

    if (showSpend) {
      cols.push({
        title: 'Spend',
        dataIndex: 'total_cost_usd',
        key: 'total_cost_usd',
        render: (v) => formatMoney(v),
        width: 110,
        align: 'right',
      });
    }

    return cols;
  }, [nameColumn, showRequests, showTokens, showSpend]);

  return (
    <Table
      className="dashboard-breakdown-table"
      rowKey={(row) => row.model || row.assistant_id || row.assistant_name}
      size="small"
      loading={loading}
      columns={columns}
      dataSource={data}
      pagination={{
        current: page,
        pageSize,
        total: (data || []).length,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        hideOnSinglePage: (data || []).length <= pageSize,
        onChange: (nextPage, nextPageSize) => {
          setPage(nextPage);
          if (nextPageSize !== pageSize) setPageSize(nextPageSize);
        },
      }}
      locale={{ emptyText: 'No data for this period' }}
    />
  );
}
